module.exports = __webpack_public_path__ + "media/application/images/ui/email-logo-929905e94cce33ef877b0f0a0f26734a.png";